module.exports = __webpack_public_path__ + "static/media/35.32fb1565.png";